import * as bc from "bc-js";

import { LangueUtils } from "@oel/js-i18n";
import { en } from "./i18n/AccueilProspectParticulier.i18n.en";
import { fr } from "./i18n/AccueilProspectParticulier.i18n.fr";
import { useEffect } from 'react';
import { GabaritNavigationUtil } from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import { ResilienceUtil } from "../../../utils/ResilienceUtil";
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function AccueilProspectParticulier() {
    let libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = libelles.titreOnglet;
        ResilienceUtil.rendreResilientSiProbleme("bc", () => bc.changerContexte("PRODUCT_Summary"));
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.ACCUEIL_PROSPECT_ADP);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="accueil-prospect-particulier">
            <h1 id="titre-page-pour-retour-contenu-principal" 
                className="dsd-sr-only" tabIndex={-1}>{libelles.titre}</h1>
            <accueil-prospect-particulier />
        </div>
    );
}
